"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _domCss = _interopRequireDefault(require("dom-css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Size = exports["default"] = /*#__PURE__*/function () {
  function Size() {
    _classCallCheck(this, Size);
    _defineProperty(this, "scrollbarWidth", false);
  }
  return _createClass(Size, [{
    key: "getComputedStyle",
    value: function (_getComputedStyle) {
      function getComputedStyle(_x) {
        return _getComputedStyle.apply(this, arguments);
      }
      getComputedStyle.toString = function () {
        return _getComputedStyle.toString();
      };
      return getComputedStyle;
    }(function (el) {
      return getComputedStyle(el);
    })
  }, {
    key: "getInnerHeight",
    value: function getInnerHeight(el) {
      var clientHeight = el.clientHeight;
      var _this$getComputedStyl = this.getComputedStyle(el),
        paddingTop = _this$getComputedStyl.paddingTop,
        paddingBottom = _this$getComputedStyl.paddingBottom;
      return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
    }
  }, {
    key: "getInnerWidth",
    value: function getInnerWidth(el) {
      var clientWidth = el.clientWidth;
      var _this$getComputedStyl2 = this.getComputedStyle(el),
        paddingLeft = _this$getComputedStyl2.paddingLeft,
        paddingRight = _this$getComputedStyl2.paddingRight;
      return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      var cacheEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (cacheEnabled && this.scrollbarWidth !== false) return this.scrollbarWidth;
      this.scrollbarWidth = 0;

      /* istanbul ignore else */
      if (typeof document !== "undefined") {
        var div = document.createElement("div");
        (0, _domCss["default"])(div, {
          width: 100,
          height: 100,
          position: "absolute",
          top: -9999,
          overflow: "scroll",
          MsOverflowStyle: "scrollbar"
        });
        document.body.appendChild(div);
        this.scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
      } else {
        this.scrollbarWidth = 0;
      }
      return this.scrollbarWidth;
    }
  }]);
}();